import React, { useState } from "react";
import { Link } from "react-router-dom";
import useServiceNavigation from "../utility/useServiceNavigation";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useLanguage } from "../contextApi/languageContext";

const Submenus = ({ subMenuItems }) => {
  const [activeMainSubmenu, setActiveMainSubmenu] = useState(null);
  const [activeChildSubmenu, setActiveChildSubmenu] = useState(null);
  const { language } = useLanguage();


  const { handleServiceClick } = useServiceNavigation();

  const handleMainSubmenuEnter = (index) => {
    setActiveMainSubmenu(index);
    setActiveChildSubmenu(0);
  };

  const handleMainSubmenuLeave = () => {
    setActiveMainSubmenu(null);
    setActiveChildSubmenu(null);
  };

  const handleChildSubmenuEnter = (index) => {
    setActiveChildSubmenu(index);
  };

  const renderChildren = (children) => {
    if (children.length > 6) {
      const half = Math.ceil(children.length / 2);
      return (
        <div className="d-flex">
          <div className="me-5">
            {children.slice(0, half).map((child) => (
              <div key={child.id} className="px-4 py-2">
                <Link
                  // to={child.link || "#"}
                  className="text-white text-decoration-none hover-effect"
                  onClick={(e) => {
                    e.preventDefault();
                    handleServiceClick(child?.name, child?.link);
                  }}
                >
                  {language === "ar" ? child.arabic_name : child.name}
                </Link>
              </div>
            ))}
          </div>
          <div>
            {children.slice(half).map((child) => (
              <div key={child.id} className="px-3 py-2">
                <Link
                  // to={child.link || "#"}
                  className="text-white text-decoration-none hover-effect"
                  onClick={(e) => {
                    e.preventDefault();
                    handleServiceClick(child?.name, child?.link);
                  }}
                >
                  {language === "ar" ? child.arabic_name : child.name}
                </Link>
              </div>
            ))}
          </div>
        </div>
      );
    }
    return children.map((child) => (
      <div key={child.id} className="px-3 py-2">
        <Link
          // to={child.link || "#"}
          className="text-white text-decoration-none hover-effect"
          onClick={(e) => {
            e.preventDefault();
            handleServiceClick(child?.name, child?.link);
          }}
        >
          {language === "ar" ? child.arabic_name : child.name}
        </Link>
      </div>
    ));
  };

  return (
    <div className="" style={{ zIndex: 999 }}>
      <div
        className="d-flex container "
        style={{ whiteSpace: "nowrap", scrollbarWidth: "none" }}
      >
        <div
          className="d-flex flex-nowrap mb-0 p-0"
          style={{ listStyle: "none" }}
        >
          {subMenuItems?.map((item, index) => {
            const isRightMost = index > subMenuItems.length - 6;
            return (
              <div
                key={item.id}
                className={`position-relative  py-2 rounded text-dark fw-semibold me-2 submenu-item ${language === "ar" ? "px-1" : "px-3"}`}
                onMouseEnter={() => handleMainSubmenuEnter(index)}
                onMouseLeave={handleMainSubmenuLeave}
              >
                <Link
                  to={item.link || "#"}
                  className="text-dark text-decoration-none hover-effect"
                >
                  {language === "ar" ? item.arabic_name : item.name}
                  {/* {item?.name} */}
                  {item.children.length > 0 && (
                    <MdKeyboardArrowDown className="fs-5" />
                  )}
                </Link>

                {/* Main Submenu Dropdown */}
                {activeMainSubmenu === index && (
                  <div
                    className={`position-absolute bg-white shadow rounded p-3 d-flex mt-2 border-top border-warning ${
                      isRightMost ? "submenu-left" : "submenu-right"
                    }`}
                    style={{ borderTopWidth: "3px" }}
                  >
                    {/* Left Column: Main Submenu Items */}
                    <div className="me-4" style={{ marginRight: "50px" }}>
                      <div className="d-flex flex-column">
                        {item.children.map((child, childIndex) => (
                          <div
                            key={child.id}
                            className="px-3  position-relative rounded text-center"
                            style={{
                              background:
                                activeChildSubmenu === childIndex
                                  ? child?.icons
                                    ? `url(${child.icons}) center/contain no-repeat, #c69933`
                                    : "#c69933"
                                  : "transparent",
                              backgroundSize:
                                activeChildSubmenu === childIndex
                                  ? "100px 100px"
                                  : "0px",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                              color:
                                activeChildSubmenu === childIndex
                                  ? "white"
                                  : "black",
                              transition: "background 0.3s ease-in-out",
                              minHeight:
                                activeChildSubmenu === childIndex
                                  ? "10rem"
                                  : "30px",
                              minWidth:
                                activeChildSubmenu === childIndex
                                  ? "150px"
                                  : "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "end",
                              padding: "5px 20px",
                              overflow: "hidden",
                              flexDirection: "column",
                              gap: "50px",
                            }}
                            onMouseEnter={() =>
                              handleChildSubmenuEnter(childIndex)
                            }
                          >
                            <Link
                              to={child.link || "#"}
                              className={`position-relative fw-semibold text-dark   ${
                                activeChildSubmenu === childIndex
                                  ? "text-white"
                                  : ""
                              }`}
                              style={{
                                zIndex: 2,
                                textDecoration: "none",
                              }}
                            >
                              {language === "ar"
                                ? child.arabic_name
                                : child.name}
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Right Section: Active Child Submenu List with Background and Overlay */}
                    {activeChildSubmenu !== null && (
                      <div
                        className="position-relative rounded p-3"
                        style={{
                          background: item.children[activeChildSubmenu]
                            ?.thumbnail
                            ? `url(${item.children[activeChildSubmenu].thumbnail}) center/cover no-repeat`
                            : "#333",
                          minWidth: "250px",
                          color: "white",
                          borderRadius: "8px",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        {/* Overlay for Readability */}
                        <div
                          className="position-absolute"
                          style={{
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(0, 0, 0, 0.7)", // Dark overlay for better readability
                            borderRadius: "8px",
                          }}
                        ></div>

                        {/* Text Content */}
                        <div className="position-relative">
                          {item.children[activeChildSubmenu]?.children?.length >
                          0 ? (
                            renderChildren(
                              item.children[activeChildSubmenu].children
                            )
                          ) : (
                            <div className="text-white">
                              No additional details
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Submenus;
